import ApiClient from '../../../services/ApiClient2';

export function getImpersonatedTokens(userUuid, applicationUuid) {
    return ApiClient.post('auth/_impersonate', {userUuid, applicationUuid});
}

export function getDeimpersonatedTokens(applicationUuid) {
    return ApiClient.post('auth/_impersonate/back', {applicationUuid});
}